import companyApi from '../../_api'
import i18n from '@/locales/'
export default {
  fetchTransactionFields: async ({ dispatch, commit, getters }) => {
    if (getters.isCallingTransactionFields) return
    try {
      commit('setIsCallingTransactionFields', true)
      const page = getters.currentPage
      const response = await companyApi.getTagTypes(page)
      const lastPage = response.headers['pagination-last-page']
      commit('setTransactionFieldsLastPage', lastPage)
      commit('setTransactionFields', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'company_fetch_transaction_fields_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingTransactionFields', false)
    }
  },
  nextTransactionFieldsPage: ({ commit, dispatch, getters }) => {
    if (getters.isCallingTransactionFields) return
    commit('incrementTransactionFieldsCurrentPage')
    dispatch('fetchTransactionFields')
  },
  createTransactionField: async (
    { commit, dispatch, getters },
    customField
  ) => {
    if (getters.isCallingTransactionFields) return
    try {
      commit('setIsCallingTransactionFields', true)
      const response = await companyApi.postTagTypes(customField)
      commit('addTransactionField', response.data)
      dispatch('SnackBars/addSuccess', i18n.t('company_create_custom_field_success'), { root: true })
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_create_custom_field_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingTransactionFields', false)
    }
  },
  updateTransactionField: async (
    { commit, dispatch, getters },
    customField
  ) => {
    if (getters.isCallingTransactionFields) return
    try {
      commit('setIsCallingTransactionFields', true)
      const response = await companyApi.putTagType(customField.id, customField)
      commit('addTransactionField', response.data)
      dispatch('SnackBars/addSuccess', i18n.t('company_update_custom_field_success'), { root: true })
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_update_custom_field_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingTransactionFields', false)
    }
  },
  deleteTransactionField: async (
    { commit, dispatch, getters },
    customFieldId
  ) => {
    if (getters.isCallingTransactionFields) return
    try {
      commit('setIsCallingTransactionFields', true)
      await companyApi.deleteTagType(customFieldId)
      commit('deleteTransactionField', customFieldId)
      dispatch('SnackBars/addSuccess', i18n.t('company_delete_custom_field_success'), { root: true })
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_delete_custom_field_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingTransactionFields', false)
    }
  },

  /* Review Flows */
  fetchReviewFlows: async ({ dispatch, commit, getters }) => {
    if (getters.isCallingReviewFlows) return
    try {
      commit('setIsCallingReviewFlows', true)
      const page = getters.reviewFlowsCurrentPage
      const response = await companyApi.getReviewStatusFlows(page)
      const lastPage = response.headers['pagination-last-page']
      commit('reviewFlowsLastPage', lastPage)
      commit('setReviewFlows', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_fetch_review_flows_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingReviewFlows', false)
    }
  },
  fetchReviewFlow: async ({ dispatch, commit, getters }, reviewFlowId) => {
    if (getters.isCallingReviewFlows) return
    try {
      commit('setIsCallingReviewFlows', true)
      const response = await companyApi.getReviewStatusFlow(reviewFlowId)
      commit('setCurrentReviewFlow', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_fetch_review_flow_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingReviewFlows', false)
    }
  },
  createReviewFlow: async ({ dispatch, commit, getters }, reviewFlowData) => {
    if (getters.isCallingReviewFlows) return
    try {
      commit('setIsCallingReviewFlows', true)
      const response = await companyApi.postReviewStatusFlow(reviewFlowData)
      commit('addReviewFlow', response.data)
      dispatch('SnackBars/addSuccess', i18n.t('company_create_review_flow_success'), { root: true })
    } catch (error) {
      throw error
    } finally {
      commit('setIsCallingReviewFlows', false)
    }
  },
  updateReviewFlow: async ({ dispatch, commit, getters }, reviewFlowData) => {
    if (getters.isCallingReviewFlows) return
    try {
      commit('setIsCallingReviewFlows', true)
      const response = await companyApi.putReviewStatusFlow(reviewFlowData.id, reviewFlowData)
      commit('addReviewFlow', response.data)
      dispatch('SnackBars/addSuccess', i18n.t('company_update_review_flow_success'), { root: true })
    } catch (error) {
      throw error
    } finally {
      commit('setIsCallingReviewFlows', false)
    }
  },
  deleteReviewFlow: async ({ dispatch, commit, getters }, reviewFlowId) => {
    if (getters.isCallingReviewFlows) return
    try {
      commit('setIsCallingReviewFlows', true)
      await companyApi.deleteReviewStatusFlow(reviewFlowId)
      commit('removeReviewFlow', reviewFlowId)
      dispatch('SnackBars/addSuccess', i18n.t('company_delete_review_flow_success'), { root: true })
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'company_delete_review_flow_error' }, { root: true })
    } finally {
      commit('setIsCallingReviewFlows', false)
    }
  },
  nextReviewFlowPage: ({ commit, dispatch, getters }) => {
    if (getters.isCallingReviewFlows) return
    commit('incrementReviewFlowsCurrentPage')
    dispatch('fetchReviewFlows')
  },
  resetReviewFlows: ({ commit }) => {
    commit('resetReviewFlows')
  },

  clearStore: ({ commit }) => {
    commit('clearStoreData')
  }
}
